import { IN_PROGRESS } from 'components/StatusIcon/constants';
import { RESET_STATE } from 'services/auth/constants';
import { ResetStateAction } from 'services/auth/types';
import {
    SPRAY_SUBMISSIONS_SET,
    SPRAY_SUBMISSIONS_CREATE_SUCCEEDED,
    SPRAY_SUBMISSIONS_DELETE_SUCCEEDED
} from './constants';
import { SpraySubmissionsState, SpraySubmissionsTypes } from './types';

const initialState = {};

export default function (
    state: SpraySubmissionsState = initialState,
    action: SpraySubmissionsTypes | ResetStateAction
): SpraySubmissionsState {
    switch (action.type) {
        case SPRAY_SUBMISSIONS_SET:
            return action.payload;
        case SPRAY_SUBMISSIONS_CREATE_SUCCEEDED: {
            const spraySubmission = action.payload;
            const { id, status } = spraySubmission;

            return {
                ...state,
                [id]: {
                    ...spraySubmission,
                    status: status || IN_PROGRESS
                }
            };
        }
        case SPRAY_SUBMISSIONS_DELETE_SUCCEEDED: {
            const stateCopy = { ...state };
            delete stateCopy[action.payload];
            return stateCopy;
        }
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
